<div #dropdownContainer (clickOutside)="clickOutside()">
    <div class="position-relative">
        <nav class="category-breadcrumb-select" [class.selection-readonly]="disabled" [attr.aria-disabled]="disabled"
            (click)="toggleDropdown($event)">
            <ol class="breadcrumb">
                <ng-template *ngIf="selectedPills.length && !hideSelectedPills; then content else select"></ng-template>
                <ng-template #content>
                    <li class="breadcrumb-pills" *ngFor="let pills of selectedPills">
                        <span class="badge badge-pill badge-primary" [class.selection-readonly]="isReadonly(pills)">{{ pills[displayKey] }}
                            <i class="ri-close-line" *ngIf="!isReadonly(pills)" (click)="removeItem(pills); $event.stopPropagation()"></i>
                        </span>
                    </li>
                </ng-template>
                <ng-template #select>
                    <li class="breadcrumb-item">
                        <a href="javascript:void(0)">{{ placeholder }}</a>
                    </li>
                </ng-template>
            </ol>
        </nav>
        <a class="cateogry-close-btn d-inline-block" [class.show]="isOpen" (click)="toggleDropdown($event)">
            <i class="ri-arrow-down-s-line down-arrow"></i>
            <i class="ri-close-line close-arrow"></i>
        </a>
        <div class="select-category-box mt-2 dropdown-open" [class.show]="isOpen" [class.infinite-results]="infiniteScroll"
            [style.top]="position === 'bottom' ? '100%' : 'auto'"
            [style.bottom]="position === 'bottom' ? 'auto' : '100%'">
            <input *ngIf="config?.isSearchable" class="form-control search-input" placeholder="Search here.." [formControl]="term">
            <div class="category-content">
                <nav *ngIf="!infiniteScroll || breadCrumbValues.length" class="category-breadcrumb" aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item" *ngIf="!optionsData?.length && !loading">
                            <a href="javascript:void(0)">{{ 'No Data Found.' }}</a>
                        </li>
                        <li class="breadcrumb-item" *ngIf="optionsData?.length && !config?.hideSelectAll">
                            <a href="javascript:void(0)" (click)="clearOptions()">{{ 'Tất cả' }}</a>
                        </li>
                        <li class="breadcrumb-item" *ngFor="let breadCrumb of breadCrumbValues; let i = index;">
                            <a href="javascript:void(0)" (click)="changeTo(breadCrumb)">{{ breadCrumb[displayKey] }}</a>
                        </li>
                    </ol>
                </nav>
                <div #optionList class="category-listing" *ngIf="optionsData?.length || infiniteScroll" (scroll)="onOptionsScroll($event)">
                    <ul>
                        <app-dropdown-list 
                            [key]="displayKey" 
                            [data]="option" 
                            [selectedPillIds]="selectedIds"
                            [subArrayKey]="subArrayKey" 
                            (selected)="onSelect($event)"
                            (subItemClicked)="subItemClicked($event)" 
                            *ngFor="let option of optionsData; trackBy: trackOption">
                        </app-dropdown-list>
                    </ul>
                    <div *ngIf="infiniteScroll && !optionsData.length && !loading" class="text-muted text-center py-2">Không có dữ liệu</div>
                </div>
                <div *ngIf="infiniteScroll" class="results-status text-muted text-center" role="status">{{ loading && !optionsData.length ? 'Đang tải...' : endOfResults && !loading && optionsData.length ? endOfResultsText : '' }}</div>
                <ng-container *ngIf="!infiniteScroll">
                    <div *ngIf="loading" class="text-muted text-center py-2" role="status">Đang tải...</div>
                    <div *ngIf="endOfResults && !loading && optionsData?.length" class="text-muted text-center py-2" role="status">{{ endOfResultsText }}</div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
